import { openBlock as t, createElementBlock as l, createElementVNode as o } from "vue";
const r = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function c(n, e) {
  return t(), l("svg", r, e[0] || (e[0] = [
    o("path", {
      fill: "currentColor",
      d: "m16.378 12.034-4.148-5.53h.507c.369 0 .738.185.968.461l3.272 4.286 3.226-4.24c.322-.322.691-.507 1.06-.507h.553l-4.194 5.53L22 17.841h-.553c-.369 0-.737-.185-.968-.507l-3.456-4.516-3.456 4.516c-.23.322-.6.46-.968.46h-.553zm-13.456.461v.369c0 1.935 1.29 3.686 3.18 4.147a4.15 4.15 0 0 0 4.654-2.258c.138-.23.368-.415.645-.415h.46a5.07 5.07 0 0 1-4.792 3.687C4.212 18.025 2 15.583 2 12.541v-1.29c0-2.489 1.751-4.747 4.24-5.207a5.07 5.07 0 0 1 5.898 5.069v1.382zm0-.921h8.295v-.461a4.148 4.148 0 0 0-5.07-4.056c-1.935.461-3.225 2.212-3.225 4.378z"
    }, null, -1)
  ]));
}
const a = { render: c };
export {
  a as default,
  c as render
};
